import posthog from 'posthog-js';
import { captureError } from '@/utils/errorHandler';

// Simple SHA-256 hash function for user ID privacy
const sha256 = async (text) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

export const trackUserIdentification = async (userId, userProperties = {}) => {
  // Only identify users in production
  if (import.meta.env.VITE_PUBLIC_APP_ENV !== 'production') {
    console.log('PostHog User Identification (dev):', userId, userProperties);
    return;
  }

  try {
    // Hash the user ID for privacy
    const hashedUserId = await sha256(userId);

    // PostHog proper user identification
    if (typeof window !== 'undefined' && posthog) {
      posthog.identify(hashedUserId, {
        ...userProperties,
        // Don't include raw email in properties for privacy
        has_email: !!userProperties.email,
        identified_at: new Date().toISOString()
      });
    }
  } catch (error) {
    captureError(error, {
      action: 'trackUserIdentification',
      component: 'userIdentification',
      extra: { hasUserId: !!userId },
    });
    console.error('Error identifying user with PostHog:', error);
  }
};

export const trackUserReset = () => {
  // Only reset in production
  if (import.meta.env.VITE_PUBLIC_APP_ENV !== 'production') {
    console.log('PostHog User Reset (dev)');
    return;
  }

  if (typeof window !== 'undefined' && posthog) {
    posthog.reset();
  }
}; 